import { render, staticRenderFns } from "./FindProof.vue?vue&type=template&id=6d3ffc6c&scoped=true&"
import script from "./FindProof.vue?vue&type=script&lang=js&"
export * from "./FindProof.vue?vue&type=script&lang=js&"
import style0 from "./FindProof.vue?vue&type=style&index=0&id=6d3ffc6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3ffc6c",
  null
  
)

export default component.exports